import React, { useState } from 'react';
import { SpRelic } from '../domain/relic';
import AddRelicDialog from './AddRelicDialog';
import Button from './Button';

interface Props {
  onSubmit: (relic: SpRelic) => void
}

function AddRelic(props: Props) {
  const [showDialog, setShowDialog] = useState(false);
  const open = () => setShowDialog(true);
  const close = () => setShowDialog(false);
  return <div>
    <Button color="secondary" className="w-full h-full flex flex-col items-center justify-center" onClick={open}>
      <span className="font-bold text-2xl">+</span>
      <span>Add Relic</span>
    </Button>
    <AddRelicDialog showDialog={showDialog} onClose={close} onSubmit={props.onSubmit} />
  </div>
}

export default AddRelic;
